import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Home, Compass, Users, BookOpen, ScanLine } from 'lucide-react';
import { usePwaNav } from '../contexts/PwaNavContext';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';
import QrScannerModal from './QrScannerModal';
import './BottomNav.css';

export default function BottomNav() {
  const { t } = useTranslation();
  const { isAuthenticated } = useCustomerAuth();
  const {
    navigate,
    showOrder,
    showPassport,
    showHistory,
    showLogin,
    showGift,
    showFriendProfile,
    showSettings,
    showFeed,
    showRestaurant,
    showVenue,
    showFriends,
  } = usePwaNav();

  const [showScanner, setShowScanner] = useState(false);

  // Hide on nested/deep contexts where the user has "drilled in"
  // AND hide entirely when not authenticated (guest landing)
  const hidden =
    !isAuthenticated ||
    showOrder || showRestaurant || showVenue ||
    showGift || showFriendProfile || showSettings || showLogin;
  if (hidden) return null;

  const onRoot = !showFeed && !showPassport && !showHistory && !showFriends;
  const onFeed = showFeed;
  const onPassportMain = showPassport;
  const onFriends = showFriends;

  const go = (path: string) => navigate(path);

  const handleScan = (qrCode: string) => {
    setShowScanner(false);
    navigate(`/order/${qrCode}`);
  };

  return createPortal(
    <>
      <nav className="bn-bar" aria-label="Bottom navigation">
        <button
          type="button"
          className={`bn-item ${onRoot ? 'bn-item--active' : ''}`}
          onClick={() => go('/')}
        >
          <Home size={20} strokeWidth={2.1} />
          <span>{t('bottomNav.home', { defaultValue: 'Главная' })}</span>
        </button>

        <button
          type="button"
          className={`bn-item ${onFeed ? 'bn-item--active' : ''}`}
          onClick={() => go(isAuthenticated ? '/feed' : '/loginclient')}
        >
          <Compass size={20} strokeWidth={2.1} />
          <span>{t('bottomNav.feed', { defaultValue: 'Лента' })}</span>
        </button>

        <button
          type="button"
          className="bn-item bn-item--scan"
          onClick={() => setShowScanner(true)}
          aria-label={t('bottomNav.scan', { defaultValue: 'Сканировать' })}
        >
          <span className="bn-scan-disc">
            <ScanLine size={22} strokeWidth={2.4} />
          </span>
        </button>

        <button
          type="button"
          className={`bn-item ${onFriends ? 'bn-item--active' : ''}`}
          onClick={() => go(isAuthenticated ? '/friends' : '/loginclient')}
        >
          <Users size={20} strokeWidth={2.1} />
          <span>{t('bottomNav.friends', { defaultValue: 'Друзья' })}</span>
        </button>

        <button
          type="button"
          className={`bn-item ${onPassportMain ? 'bn-item--active' : ''}`}
          onClick={() => go(isAuthenticated ? '/passport' : '/loginclient')}
        >
          <BookOpen size={20} strokeWidth={2.1} />
          <span>{t('bottomNav.passport', { defaultValue: 'Паспорт' })}</span>
        </button>
      </nav>

      {showScanner && (
        <QrScannerModal onClose={() => setShowScanner(false)} onScan={handleScan} />
      )}
    </>,
    document.body
  );
}
